<template>
  <div class="text-center padding-xl">
    <el-steps :active="1" align-center class="padding-tb-xl" process-status="finish">
      <el-step title="选择订户类型"></el-step>
      <el-step title="填写征订单（零散）"></el-step>
      <el-step title="订单支付"></el-step>
      <el-step title="发票开具"></el-step>
    </el-steps>
    <div class="solid-top padding-tb" style="padding: 0">
      <div class="flex justify-between align-center">
        <div class="text-red text-lg flex justify-start align-center">
          <div><i class="cuIcon-titles padding-left"></i> 期刊信息</div>
          <div v-if="products.length>1" class="text-bold text-xxl padding-left-xl">
            <button type="button" class=" btn-danger round cu-btn bg-red" @click="addProduct"><i class="cuIcon-add"></i>增加期刊
            </button>
          </div>
        </div>
        <div class="padding-right">合计金额：<span class="text-red">¥ {{ order.amount }}</span></div>
      </div>
      <div class="padding-top-xl">
        <el-form :inline="true" :model="order" v-for="(item, index) in order.list" label-width="80px" :key="index"
                 class=" text-left">
          <el-form-item style="width: 60px;" class="text-right">
            <button v-if="index >0 " type="button" @click="removeProduct($event, index)"
                    class="cu-btn cuIcon round lines-red sm"><i
              class="cuIcon-move"></i></button>
          </el-form-item>
          <el-form-item label="期刊名称">
            <el-select v-if="products.length>1" v-model="item.product"
                       @change="productChanged(item, $event)"
                       placeholder="请选择期刊">
              <el-option v-for="(i, idx) in products" :key="idx" :label="i.bookFullname"
                         :value="i.bookFullname"></el-option>
            </el-select>
            <el-input id="aa" :disabled="true" v-else v-model="item.product"></el-input>
          </el-form-item>
          <el-form-item label="份数">
            <el-input-number style="width: 140px;" v-model="item.qty" :min="1"
                             @change="productAmountChanged(item)"></el-input-number>
          </el-form-item>
          <el-form-item v-if="ISSUE_RANGE" label="期数">
            <el-col :span="11">
              <el-select style="width: 70px;" v-model="item.issueStart" @change="productAmountChanged(item, true)">
                <el-option v-for="(j, k) in productsMap[item.product].bookQs" :key="k" :label="j"
                           :value="j"></el-option>
              </el-select>
            </el-col>
            <el-col class="line text-center" :span="2">
              <div class="padding-right"> ~</div>
            </el-col>
            <el-col :span="11">
              <el-select style="width: 70px;" v-model="item.issueEnd" @change="productAmountChanged(item, false)">
                <el-option v-for="(j, k) in productsMap[item.product].bookQs" :key="k" :label="j"
                           :value="j"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item>
            <label class="padding-left">金额: <span class="text-red">¥ {{ item.amount }}</span></label>
          </el-form-item>
        </el-form>
      </div>
      <div class="solid-top padding-tb">
        <div class="flex justify-between align-center" v-if="serverConfig.subCategoryEnabled===true || serverConfig.subPropertyEnabled===true">
          <div class="text-red text-lg flex justify-start align-center">
            <div><i class="cuIcon-titles padding-left"></i> 订户信息</div>
          </div>
        </div>
        <div class="padding">
          <div class="flex align-center padding-tb">
            <div class="flex align-center" v-if="serverConfig.subCategoryEnabled===true">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                订户类别：
              </div>
              <div>
                <el-select v-model="order.subCategory" size="small" style="width:197px" placeholder="请选择">
                  <el-option label="个人" value="个人"></el-option>
                  <el-option label="单位" value="单位"></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex justify-start align-center padding-left-xl" v-if="serverConfig.subPropertyEnabled===true">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                订户性质：
              </div>
              <div>
                <el-select v-model="order.orgProperty" placeholder="请选择" size="small" style="width:197px">
                  <el-option
                    v-for="item in orgProperties"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between align-center">
          <div class="text-red text-lg flex justify-start align-center">
            <div><i class="cuIcon-titles padding-left"></i> 收件信息</div>
            <div class="padding-left flex justify-start align-end">
              <el-switch v-model="isSaveAddress"></el-switch>
              <div class="text-sm padding-left-sm">保存为默认收件人</div>
            </div>
          </div>
        </div>
        <div class="padding">
          <div class="flex align-center padding-top" v-if="serverConfig.subOrgEnabled===true">
            <div class="flex align-center">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                {{ labelInfos.orgLabelType1 }}：
              </div>
              <div>
                <el-input @change="orgSelected" id="org_input" disabled v-model="selectedOrgLabel"
                          @click.native="orgDialogShow = true"
                          size="small"></el-input>
              </div>
            </div>
          </div>
          <div class="flex align-center padding-top">
            <div class="flex align-center">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                收件单位：
              </div>
              <div>
                <el-input v-model="address.addressOrg" style="min-width: 508px;" size="small"></el-input>
              </div>
            </div>
          </div>
          <div class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                收件人：
              </div>
              <div>
                <el-input v-model="address.addressPerson" size="small"></el-input>
              </div>
            </div>
            <div class="flex justify-start align-center padding-left-xl">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                邮编：
              </div>
              <div>
                <el-input v-model="address.addressZip" size="small"></el-input>
              </div>
            </div>
          </div>
          <div class="flex align-center padding-top">
            <div class="flex align-center">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                手机号：
              </div>
              <div>
                <el-input v-model="address.addressPhone" size="small"></el-input>
              </div>
            </div>
            <div class="flex justify-start align-center padding-left-xl">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                座机：
              </div>
              <div>
                <el-input v-model="address.addressTelephone" size="small" placeholder="如无座机，请填写‘无’"></el-input>
              </div>
            </div>
          </div>
          <div class="flex align-center padding-top">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              省市区：
            </div>
            <div>
              <v-region v-model="addressSelected" @values="regionChange" class="bg-white"></v-region>
            </div>
          </div>
          <div class="flex align-center padding-tb">
            <div class="flex justify-start align-center">
              <div class="info-label">
                <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
                详细地址：
              </div>
              <div>
                <el-input v-model="address.addressStreet" style="min-width: 508px;" size="small"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding-xl" style="padding: 0">
      <button v-if="order.id" class="cu-btn line-red round lg margin-lr" style="width:200px" @click="nav2List">查看订单列表
      </button>
      <button v-else class="cu-btn bg-red round lg margin-lr" style="width:200px" @click="$router.back()">上一步
      </button>
      <button class="cu-btn bg-red round lg margin-lr" style="width:200px" @click="save">{{ labelInfos.payButton }}</button>
    </div>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               :title=labelInfos.orgLabelType1Msg
               :visible.sync="orgDialogShow"
               width="30%">
      <div style="height: 400px;display: block; overflow-y: scroll">
        <el-tree
          :data="orgTree"
          :props="defaultProps"
          node-key="id"
          :default-expanded-keys="expandeds"
          accordion
          @node-click="handleNodeClick">
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orgDialogShow = false">取消</el-button>
        <el-button type="primary" @click="orgSelected">选择</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bs from '@/services/data/bs'
import config from '../../public/config/config'

export default {
  name: 'subscribe',
  data () {
    return {
      labelInfos: config.labelInfos,
      selectedOrg: {},
      expandeds: [],
      serverConfig: config.serverConfig,
      selectedOrgLabel: '',
      orgDialogShow: false,
      org: config.org,
      orgTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      submitting: false,
      ISSUE_RANGE: config.ISSUE_RANGE,
      isSaveAddress: true,
      products: [],
      productsMap: { '': { issue: null } },
      order: {
        type: '零散订阅',
        community: '',
        amount: 0,
        state: 0,
        list: [{
          product: '',
          qty: 0,
          issueStart: 1,
          issueEnd: null,
          amount: 0,
          price: 0,
          itemCode: '',
          rowNo: 1
        }]
      },
      address: {
        addressOrg: '',
        addressPhone: '',
        addressTelephone: '',
        addressArea: '',
        addressStreet: '',
        addressZip: '',
        addressPerson: '',
        addressProvinceCode: '',
        addressProvinceName: '',
        addressCityCode: '',
        addressCityName: '',
        addressDistrictCode: '',
        addressDistrictName: ''
      },
      addressSelected: {
        province: '',
        city: '',
        area: '',
        town: ''
      }
    }
  },
  watch: {
    addressSelected (val, oldVal) {
      this.address.addressArea = this.addressSelected.province + ',' + this.addressSelected.city + ',' + this.addressSelected.area
    },
    'address.addressZip' (val) {
      if (val) {
        val = val.replace(/[^0-9]/ig, '')
        if (val.length > 6) {
          val = val.slice(0, 6)
        }
        this.address.addressZip = val
      }
    }
  },
  created () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    if (sessionStorage.getItem('order')) {
      this.order = JSON.parse(sessionStorage.getItem('order'))
      this.selectedOrgLabel = this.order.orgName
    }
    if (sessionStorage.getItem('products')) {
      this.products = JSON.parse(sessionStorage.getItem('products'))
      for (let i = 0; i < this.products.length; i++) {
        const p = this.products[i]
        this.productsMap[p.bookFullname] = p
      }
    }
    if (sessionStorage.getItem('orgProperties')) {
      this.orgProperties = JSON.parse(sessionStorage.getItem('orgProperties'))
    }
    if (this.user) {
      this.address.addressOrg = this.user.addressOrg
      this.address.addressPhone = this.user.addressPhone
      this.address.addressTelephone = this.user.addressTelephone
      this.address.addressStreet = this.user.addressStreet
      this.address.addressZip = this.user.addressZip
      this.address.addressPerson = this.user.addressPerson
      if (this.user.addressArea) {
        this.address.addressArea = this.user.addressArea
        const areas = this.user.addressArea.split(',', -1)
        this.addressSelected.province = areas[0]
        this.addressSelected.city = areas[1]
        this.addressSelected.area = areas[2]
      }
    }
    if (this.products.length === 1 && !this.order.id) {
      const item = this.order.list[0]
      item.product = this.products[0].bookFullname
      item.issueEnd = this.productsMap[item.product].bookQs
      item.qty = 1
      item.amount = parseFloat((this.productsMap[item.product].bookPrice * item.issueEnd).toFixed(2))
      item.price = this.productsMap[item.product].bookPrice
      item.itemCode = this.productsMap[item.product].invoiceItemCode
      this.totalAmount()
    }
    if (this.serverConfig.subOrgEnabled === true) {
      bs.data.org((res) => {
        this.orgTree.push(res.data)
        this.expandeds = [res.data.id]
      })
    }
  },
  methods: {
    orgSelected () {
      this.order.orgId = this.selectedOrg.id
      this.order.orgName = this.selectedOrg.label
      this.selectedOrgLabel = this.selectedOrg.label
      this.orgDialogShow = false
    },
    handleNodeClick (data) {
      this.selectedOrg = data
    },
    regionChange (val) {
      if (val) {
        this.address.addressProvinceCode = val.province.key
        this.address.addressProvinceName = val.province.value
        this.address.addressCityCode = val.city.key
        this.address.addressCityName = val.city.value
        this.address.addressDistrictCode = val.area.key
        this.address.addressDistrictName = val.area.value
      }
    },
    nav2List () {
      this.$router.push({ path: '/pages/order-list' })
    },
    save () {
      if (this.submitting === true) {
        return
      } else {
        this.submitting = true
      }
      if (!this.validateProducts()) {
        this.$message.error('必须选择一个期刊')
        this.submitting = false
        return false
      }
      if (!this.validateSubProperties()) {
        this.$message.error('请完善订户信息')
        this.submitting = false
        return false
      }
      if (!this.validateAddress()) {
        this.$message.error('请完善收件信息')
        this.submitting = false
        return false
      }
      for (let i = 0; i < this.order.list.length; i++) {
        const item = this.order.list[i]
        item.addressOrg = this.address.addressOrg
        item.addressPhone = this.address.addressPhone
        item.addressTelephone = this.address.addressTelephone
        item.addressStreet = this.address.addressStreet
        item.addressZip = this.address.addressZip
        item.addressPerson = this.address.addressPerson
        item.addressArea = this.address.addressArea
        item.addressProvinceCode = this.address.addressProvinceCode
        item.addressProvinceName = this.address.addressProvinceName
        item.addressCityCode = this.address.addressCityCode
        item.addressCityName = this.address.addressCityName
        item.addressDistrictCode = this.address.addressDistrictCode
        item.addressDistrictName = this.address.addressDistrictName
      }
      bs.order.save(this.order, this.isSaveAddress, (res) => {
        if (res.code === 200) {
          sessionStorage.setItem('order', JSON.stringify(res.data))
          if (this.isSaveAddress) {
            bs.user.getUser((res) => {
              if (res.code === 200) {
                sessionStorage.setItem('user', JSON.stringify(res.data))
              }
            })
          }
          this.$message({
            message: '订单信息保存成功',
            type: 'success'
          })
          this.nextStep()
          this.submitting = false
        } else if (res.code === 300) {
          this.$message.error(res.error)
        }
      })
    },
    validateSubProperties () {
      if (this.serverConfig.subCategoryEnabled === true && (!this.order.subCategory || this.order.subCategory.trim() === '')) {
        return false
      }
      if (this.serverConfig.subPropertyEnabled === true && (!this.order.orgProperty || this.order.orgProperty.trim() === '')) {
        return false
      }
      return true
    },
    validateAddress () {
      if (this.serverConfig.subOrgEnabled === true && this.selectedOrgLabel === '') {
        return false
      }
      if (this.org.enabled === true && this.selectedOrgLabel === '') {
        return false
      }

      let rtn = true
      Object.getOwnPropertyNames(this.address).forEach(key => {
        if (key !== '__ob__' && (!this.address[key] || this.address[key].trim() === '')) {
          rtn = false
        }
      })
      return rtn
    },
    validateProducts () {
      return this.order.list[0].product !== ''
    },
    removeProduct (e, index) {
      this.order.list.splice(index, 1)
    },
    productChanged (item, e) {
      let duplicated = 0
      for (let i = 0; i < this.order.list.length; i++) {
        if (this.order.list[i].product === e) {
          duplicated++
        }
      }
      if (duplicated > 1) {
        item.product = ''
        item.qty = 1
        item.issueStart = 1
        item.issueEnd = null
        item.amount = 0
        this.$message({
          message: '无法选择已经选择过的期刊！',
          type: 'warning'
        })
      } else {
        item.issueEnd = this.productsMap[item.product].bookQs
        item.qty = 1
        item.amount = parseFloat((this.productsMap[item.product].bookPrice * item.issueEnd).toFixed(2))
        item.price = this.productsMap[item.product].bookPrice
        item.itemCode = this.productsMap[item.product].invoiceItemCode
        this.totalAmount()
      }
    },
    addProduct () {
      this.order.list.push({
        product: '',
        qty: 1,
        issueStart: 1,
        issueEnd: null,
        amount: 0
      })
    },
    nextStep () {
      this.$router.push({ path: '/pages/subscribe/pay' })
    },
    productAmountChanged (item, isLeft) {
      if (item.product === '') {
        return false
      }
      if (isLeft === true && item.issueStart > item.issueEnd) {
        item.issueStart = item.issueEnd
      } else if (isLeft === false && item.issueEnd < item.issueStart) {
        item.issueEnd = item.issueStart
      }
      item.amount = parseFloat((item.qty * (item.issueEnd - item.issueStart + 1) * this.productsMap[item.product].bookPrice).toFixed(2))
      this.totalAmount()
    },
    totalAmount () {
      let amount = 0
      for (let i = 0; i < this.order.list.length; i++) {
        amount = amount + this.order.list[i].amount
      }
      this.order.amount = amount
    }
  }
}
</script>
<style>

#aa {
  background-color: white !important;
  color: #606266;
  width: 240px;
}

#org_input {
  cursor: pointer;
  background-color: #fff;
  pointer-events: none;
}
</style>
<style scoped>
.info-label {
  width: 90px;
  padding: 2px 0;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

.info-label div {
  padding-top: 3px;
  padding-right: 2px;
}

.view-label {
  min-width: 200px;
}

</style>
